export default __webpack_public_path__ + "static/media/placeholder_business06-es-web.83479e9c.png";